<template>
  <div class="left">
    <div class="mx-auto">
      <b-container fluid>
        <b-row id="left-content">
          <b-col class="head w-100">
            <Headings :data="heading" />
          </b-col>
          <b-row class="para-left">
            <b-col class="left-last-content">
              <p class="para">{{ paragraph }}</p>
            </b-col>
          </b-row>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: "leftContent",
  props: ["heading", "paragraph"],
};
</script>

<style scoped>
#left-content > .head {
  padding-right: 0;
}
#left-content > .para-left {
  padding-left: 15px;
}
.left-last-content {
  color: var(--mainBlueColor);
  padding-top: 0;
  padding-right: 0;
}
.para-left {
  text-align: left;
  padding-top: 2rem;
}
.para {
  font-size: 16px;
  text-align: justify;
  width: 100%;
}

@media (max-width: 767px) {
  .left-last-content {
    color: var(--mainBlueColor);
    padding-top: 0;
    padding-right: 15px;
  }
  .para {
    font-size: 0.75rem;
    justify-content: center;
    margin-bottom:0;
  }

  #left-content > .para-left {
    padding-left: 0;
  }
    #left-content > .head {
    padding-right: 15px;
  }
}

@media (max-width:320px){
  .para {
    font-size: 0.73rem;
    justify-content: center;
    margin-bottom: 1rem;
  }
  .para-left {
  text-align: left;
  padding-top: 0rem;
  }
}

@media (max-width:240px){
  .para {
    font-size: 0.6rem;
    justify-content: center;
    margin-bottom: 1rem;
  }
  .para-left {
  text-align: left;
  padding-top: 0rem;
  }
}
</style>
